// GA4 + ecommerce event helpers for GOSHI.
// Safe no-op if gtag isn't loaded yet (SPA-friendly).
import { devError } from "./devLog";

const isReady = () => typeof window !== "undefined" && typeof window.gtag === "function";

const track = (event, params = {}) => {
  if (!isReady()) return;
  try { window.gtag("event", event, params); } catch (e) { devError("gtag error", e); }
};

export const trackPageView = (path) => {
  if (!isReady()) return;
  window.gtag("event", "page_view", { page_path: path || (typeof window !== "undefined" ? window.location.pathname : "") });
};

export const trackViewItem = (product) => {
  track("view_item", {
    currency: "INR",
    value: Number(product?.price || 0),
    items: [{
      item_id: product?.product_id,
      item_name: product?.name,
      item_category: product?.category,
      price: Number(product?.price || 0),
      quantity: 1,
    }],
  });
};

export const trackAddToCart = (product, qty = 1, size) => {
  track("add_to_cart", {
    currency: "INR",
    value: Number(product?.price || 0) * qty,
    items: [{
      item_id: product?.product_id,
      item_name: product?.name,
      item_category: product?.category,
      item_variant: size,
      price: Number(product?.price || 0),
      quantity: qty,
    }],
  });
};

export const trackBeginCheckout = (cart, total, coupon) => {
  track("begin_checkout", {
    currency: "INR",
    value: Number(total || 0),
    coupon: coupon || undefined,
    items: (cart || []).map(i => ({
      item_id: i.product_id,
      item_name: i.name,
      item_variant: i.size,
      price: Number(i.price || 0),
      quantity: Number(i.quantity || 1),
    })),
  });
};

export const trackPurchase = (order) => {
  track("purchase", {
    transaction_id: order?.order_id,
    currency: "INR",
    value: Number(order?.total || 0),
    tax: 0,
    shipping: 0,
    coupon: order?.coupon_code || undefined,
    items: (order?.items || []).map(i => ({
      item_id: i.product_id,
      item_name: i.name,
      item_variant: i.size,
      price: Number(i.price || 0),
      quantity: Number(i.quantity || 1),
    })),
  });
};

export const trackSearch = (term) => track("search", { search_term: term });
export const trackAddToWishlist = (product) => track("add_to_wishlist", {
  currency: "INR",
  value: Number(product?.price || 0),
  items: [{ item_id: product?.product_id, item_name: product?.name }],
});
